
export const BUSINESS_TEXTS = {
    HEADERS: {
        MAIN_HEADER: "Business information",
        FULL_NAME: "Your full name",
        EMAIL_ADDRESS: "Work email address",
        BUSINESS_TYPE: "Please select a business type",
        BUSINESS_NAME: "Business legal name",
        DBA: "DBA or tradename if applicable ",
        BUSINESS_TIN:"Business TIN (EIN, SSN)",
        BUSINESS_PHONE:"Business Phone Number",
        BUSINESS_PHONE_SUB_HEADER:"Required for non-commercial, time-sensitive notifications about your application. We will never sell your data to anyone.",
        BUSINESS_ADDRESS: "Business address",
        EMPLOYEES: "Number of Employees",
        EMPLOYEES_ERROR: "Employees number should be between 0 and 100",
    },
    PLACE_HOLDERS: {
        GENERAL: "Write here...",
        BUSINESS_ADDRESS: "3 W 23rd St, New York, NY 10010",
        CELL_PHONE_NUMBER: "(123) 456–7890",
        BUSINESS_TYPE: "Choose your answer",
    },
    PROP_NAMES: {
        FULL_NAME: "fullName",
        EMAIL_ADDRESS: "emailAddress",
        BUSINESS_TYPE: "businessType",
        BUSINESS_NAME: "BusinessName",
        DBA: "DBA",
        BUSINESS_TIN:"TIN",
        BUSINESS_PHONE:"BusinessPhone",
        BUSINESS_ADDRESS: "BusinessAddress",
        EMPLOYEES: "employeesAmount"
    }
};

export const FINANCE_TEXTS = {
    HEADERS: {
        MAIN_HEADER: "Loan request",
        LOAN_REQUEST: "Loan amount",
        LOAN_PURPOSE: "Use of proceeds",
        BANK_NAME: "Bank name",
        BANK_NAME_SUB_HEADER: "Insert you bank account details for depositing the funds",
        ACCOUNT_ROUTING: "Routing number",
        ROUTING_ERROR: "Invalid roting number",
        ACCOUNT_NUMBER: "Account number",
        ACCOUNT_OWNER: "Account owner name",
    },
    PLACE_HOLDERS: {
        GENERAL: "Write here...",
    },
    PROP_NAMES: {
        LOAN_REQUEST: "loanAmount",
        LOAN_PURPOSE: "loanPurpose",
        BANK_NAME: "bankName",
        ACCOUNT_ROUTING: "routingNumber",
        ACCOUNT_NUMBER: "accountNumber",
        ACCOUNT_OWNER: "accountOwnerName",
    }
}

export const GENERAL_QUESTIONS_TEXT = {
    HEADERS: {
        MAIN_HEADER: "General questions",
        SUB_HEADER: "If the 1st or 2nd or 5th or 6th questions below are answered with a \"Yes\", the loan will not be approved.",
        Q1: "Is the Applicant or any owner of the Applicant presently suspended, debarred, proposed for debarment, declared ineligible,voluntarily excluded from participation in this transaction by any Federal department or agency, or presently involved in any bankruptcy?",
        Q2: "I Has the Applicant, any owner of the Applicant, or any business owned or controlled by any of them, ever obtained a direct or\n" +
            "guaranteed loan from SBA or any other Federal agency that is currently delinquent or has defaulted in the last 7 years and\n" +
            "caused a loss to the government? ",
        Q3: "Is the Applicant or any owner of the Applicant an owner of any other business, or have common management with, any other\n" +
            "business? If yes, list all such businesses and describe the relationship on a separate sheet identified as addendum A.",
        Q4: "Has the Applicant received an SBA Economic Injury Disaster Loan between January 31, 2020 and April 3, 2020? If yes,\n" +
            "provide details on a separate sheet identified as addendum B.",
        Q5: "Is the Applicant (if an individual) or any individual owning 20% or more of the equity of the Applicant subject to an indictment, criminal information, arraignment, or other means by which formal criminal charges are brought in any jurisdiction, or presently incarcerated, or on probation or parole?",
        Q6: "Within the last 5 years, for any felony, has the Applicant (if an individual) or any owner of the Applicant 1) been convicted; 2) pleaded guilty; 3) pleaded nolo contendere; 4) been placed on pretrial diversion; or 5) been placed on any form of parole or probation (including probation before judgment)?",
        Q7: "Is the United States the principal place of residence for all employees of the Applicant included in the Applicant’s payroll calculation above?",
        Q8: "Is the Applicant a franchise that is listed in the SBA’s Franchise Directory?",
        BANK_QUESTION: "Would like to send the application to your bank?",
        BANK_EMAIL_ADDRESS: "Bank email address"
    },
    PROP_NAMES: {
        Q1: "q1",
        Q2: "q2",
        Q3: "q3",
        Q4: "q4",
        Q5: "q5",
        Q6: "q6",
        Q7: "q7",
        Q8: "q8",
        BANK_QUESTION: "q9",
        BANK_EMAIL_ADDRESS: "bankEmailAddress"
    },
    PLACE_HOLDERS: {
        GENERAL: "Write here...",
    },
}

export const OWNERSHIP_TEXT = {
    HEADERS: {
        MAIN_HEADER: "Business ownership",
        MAIN_SUB_HEADER: "List all owners of 20% equity or more in your company",
        OWNER_NAME: "Owner name",
        TITLE: "Title",
        OWNERSHIP: "Ownership %",
        TIN: "TIN(EIN, SSN)",
        TIN_ERROR: "TIN(EIN, SSN) Must be 9 digits",
        OWNERSHIP_ERROR: "Ownership percentage should be from 20 to 100",
        ADDRESS: "Address",
        ANOTHER_OWNERSHIP: "Would you like to add another owner?"
    },
    PLACE_HOLDERS: {
        GENERAL: "Write here...",
        SELECT: "Please select",
        ADDRESS: "43W 23rd St, New York, NY 10010"
    },
    PROP_NAMES: {
        OWNER_NAME: "ownerName",
        TITLE: "ownerTitle",
        OWNERSHIP: "ownerPercentage",
        TIN: "ownerTin",
        ADDRESS: "ownerAddress",
        ANOTHER_OWNERSHIP: "anotherOwnership"

    }
}

export const DOCUMENTATION_TEXT = {
    HEADERS: {
        MAIN_HEADER: "Documentation",
        MAIN_SUB_HEADER: "Provide documentation with sufficient detail to support the loan amount.",
        FIRST_PDF: "2019 Payroll Processor Records from a 3rd party provider (i.e. ADP, Paychex, Oracle, etc).",
        FIRST_PDF_SUB_HEADER: "This should have a) total payroll for full year 2019, by employee, as reported to the IRS. These records should also, b), have a summary full year 2019 page for all employees and break out at the following items as they are applicable to your business :  Salary, wages, commissions, other compensatin, cash tips or equivelant, vacation pay, FMLA leave or equivelant, vacation, sick leave, allowance for seperation or dismissal, payments for all Group health care coverage including insurance premiums, payments for all retirement plan contributions and costs.",
        SECOND_PDF: "IRS Form W3, or Forms 941, for the entire year of 2019.",
        THIRD_PDF: "**If applying as an Independent Contractor** 2019 Independent Contractor Costs – Listing of 1099s-MISC for 2019 independent contractors, by person, as reported to the IRS.  (Note: Do NOT include 1099’s for services).",
    },
    PROP_NAMES: {
        FIRST_PDF: "sbaFirstPdfFile",
        SECOND_PDF: "sbaSecondPdfFile",
        THIRD_PDF: "sbaThirdPdfFile",
    }
}

export const FIRST_FINISH_TEXTS = {
    HEADER: "Your complete SBA PPP application form is on its way to you now.",
    SUB_HEADER: "Please note your bank will need additional supporting documents to process your application."
}

export const FINAL_FINISH_TEXTS = {
    HEADER: "Thank you",
    SUB_HEADER: "Your application is now complete."
}

export const CALCULATOR_TEXTS = {
    HEADERS : {
        MAIN_HEADER: "Loan amount calculator",
        MAIN_SUB_HEADER: "Calculate your estimated eligible loan amount, according to the SBA's parameters.",
        AGGREGATE_PAYROLL_COSTS: "Aggregate Payroll Costs",
        WAGES: "Salaries, wages, commissions, or similar compensation",
        TIPS: "Cash tips or the equivalent",
        VACATION: "Payment for vacation, parental, family, medical, or sick leave",
        ALLOWANCE: "Allowance for separation or dismissal",
        EMPLOYEE_BENEFITS: "Payment for provision of employee benefits (group health care coverage, including insurance premiums, and retirement)",
        TAXES: "Payment of state and local taxes assessed on compensation of employees",
        INDIVIDUAL: "Individual Payroll Costs in Excess of $100,000 (if applicable)*",
        OUTSTANDING_BALANCE: "Outstanding Balance of EIDL Loan (if applicable)**",
        ADVANCE: "EIDL $10,000 Advance Paid to Applicant**  (if applicable)**"
    },
    RESULT_HEADERS: {
        ANNUAL_PAYROLL: "Annual Payroll Costs",
        ADJUSTED_PAYROLL: "Adjusted Payroll Costs",
        MONTHLY_PAYROLL: "Average Monthly Qualifying Payroll (A divided by 12 )",
        MULTIPLE: "Multiply by 2.5 (months)",
        MAXIMUM: "ESTIMATED ELIGIBLE LOAN AMOUNT"
    },
    PROP_NAMES: {
        WAGES: "wages",
        TIPS: "tips",
        VACATION: "vacation",
        ALLOWANCE: "allowance",
        EMPLOYEE_BENEFITS: "benefits",
        TAXES: "taxes",
        INDIVIDUAL: "individualPayrollCosts",
        AGGREGATE_PAYROLL_COSTS: "payrollCosts",
        ADJUSTED_PAYROLL: "adjustPayroll",
        MONTHLY_PAYROLL: "averageMonthlyQualifyingPayroll",
        MULTIPLE: "multipleMonths",
        OUTSTANDING_BALANCE: "outstandingBalanceEIDL",
        ADVANCE: "EIDLAdvance",
        ANNUAL_PAYROLL: "annualPayroll",
        MAXIMUM_LOAN: "maximumLoan"
    },
    EXPLANATION_TEXTS: {
        PARAGRAPH_A: "* To calculate your Average Monthly Payroll we'll use your annual aggregated payroll for 2019, excluding costs over $100,000 on an annualized basis for each employee. If you are a seasonal business, please insert annual payroll costs that reflect the time period between February 15, 2019 and June 30, 2019, excluding costs over $100,000 on an annualized basis for each employee. If you are a new business, your average monthly payroll may be calculated using the time period from January 1, 2020 to February 29, 2020, excluding costs over $100,000 on an annualized basis for each employee.",
        PARAGRAPH_B: "** If you were approved for an EIDL loan that was not used for payroll costs, it does not affect your eligibility for a PPP loan and does NOT need to be included here. However, if the EIDL was made between Jan 31, 2020 and April 3, 2020, and was used for payroll costs, your PPP loan must be used to refinance your EIDL. Proceeds from any advance up to $10,000 on the EIDL will be deducted from your Estimated Eligible Loan Amount"
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormSBA/SBAFormTexts.ts